<template>
  <div class="map-container" v-show="showMap">
    <div class="google-map" ref="googleMap"></div>
    <template v-if="Boolean(this.google) && Boolean(this.map)">
      <slot :google="google" :map="map" />
    </template>
  </div>
</template>

<style scoped lang="scss">
.map-container,
.google-map {
  width: 100%;
  height: 100%;
}
</style>

<script>
import GoogleMapsApiLoader from "google-maps-api-loader";

export default {
  props: {
    mapConfig: Object,
    apiKey: {
      type: String,
      default: "AIzaSyAjCo5RBMqpbdHSqH7o014NpUEIyeNmxJo"
    },
    sendCoordinates: {
      type: Function
    },
    sendCity: {
      type: Function,
      default:()=>{}
    },
    sendState: {
      type: Function,
      default:()=>{}
    },
    sendPostalCode: {
      type: Function,
      default:()=>{}
    },
    latitude: {},
    longitude: {},
    state:{},
    city:{},
    showMap: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      google: null,
      map: null,
      marker: null
    };
  },

  async mounted() {
    const googleMapApi = await GoogleMapsApiLoader({
      libraries: ["places"],
      apiKey: this.apiKey
    });
    this.google = googleMapApi;
    this.initializeMap();
  },

  methods: {
    initializeMap() {
      const self = this;
      const mapContainer = this.$refs.googleMap;
      self.map = new this.google.maps.Map(mapContainer, this.mapConfig);
      const input = document.getElementById("pac-input");
      input.placeholder = "";
      const searchBox = new self.google.maps.places.SearchBox(input);

      self.map.addListener("bounds_changed", e => {
        searchBox.setBounds(self.map.getBounds());
      });
      let markers = [];

      searchBox.addListener("places_changed", () => {
        const places = searchBox.getPlaces();

        if (places.length === 0) {
          return;
        }
        if (markers && markers.length > 0) {
            markers.forEach(marker => {
                marker.setMap(null);
            });
            markers = [];
        }

        const bounds = new self.google.maps.LatLngBounds();
        places.forEach(place => {
          
          let postal_code = "";

          if (!place.geometry || !place.geometry.location) {
            return;
          } else {
            let latitude = place.geometry.location.lat();
            let longitude = place.geometry.location.lng();
            self.sendCoordinates(latitude, longitude);
          }
          if(!place.address_components){
            return;
          }else{
            for(let i = 0; i < place.address_components.length; i++){
              
              if(place.address_components[i].types[0]=='locality'){
                let city = place.address_components[i].long_name;
                self.sendCity(city);
              }
              if(place.address_components[i].types[0]=='administrative_area_level_1'){
                let state = place.address_components[i].long_name;
                self.sendState(state);
              }
              if(place.address_components[i].types[0]=='postal_code'){
                postal_code = place.address_components[i].long_name;
              }
            }
          }
          this.$emit("select", place.formatted_address);
          self.sendPostalCode(postal_code);

          const icon = {
            url: place.icon,
            size: new self.google.maps.Size(71, 71),
            origin: new self.google.maps.Point(0, 0),
            anchor: new self.google.maps.Point(17, 34),
            scaledSize: new self.google.maps.Size(25, 25)
          };
          if (self.marker) {
            self.marker.setMap(null);
          }

          self.marker = new self.google.maps.Marker({
            position: place.geometry.location,
            map: self.map,
            draggable: true
          });
          if (place.geometry.viewport) {
            // Only geocodes have viewport.
            bounds.union(place.geometry.viewport);
          } else {
            bounds.extend(place.geometry.location);
          }
        });
        self.map.fitBounds(bounds);
      });

      self.google.maps.event.addListener(self.map, "click", function(event) {
        let location = event.latLng;

        self.sendCoordinates(event.latLng.lat(), event.latLng.lng());

        if (self.marker) {
          self.marker.setMap(null);
        }

        self.marker = new self.google.maps.Marker({
          position: location,
          map: self.map,
          draggable: true
        });

        self.google.maps.event.addListener(self.marker, "drag", function(
          event
        ) {
          self.sendCoordinates(event.latLng.lat(), event.latLng.lng());
        });
      });
      if (self.latitude && self.longitude) {
        let location = new self.google.maps.LatLng(
          self.latitude,
          self.longitude
        );

        self.marker = new self.google.maps.Marker({
          position: location,
          map: self.map,
          draggable: true
        });

        self.google.maps.event.addListener(self.marker, "drag", function(
          event
        ) {
          self.sendCoordinates(event.latLng.lat(), event.latLng.lng());
        });
      }
    }
  },

  watch: {
    latitude(lat) {
      if (lat && self.google) {
        const self = self;
        self.latitude = lat;

        if (self.marker) {
          self.marker.setPosition(
            new self.google.maps.LatLng(self.latitude, self.longitude)
          );
        } else {
          self.marker = new self.google.maps.Marker({
            position: location,
            map: self.map,
            draggable: true
          });

          self.google.maps.event.addListener(self.marker, "drag", function(
            event
          ) {
            self.sendCoordinates(event.latLng.lat(), event.latLng.lng());
          });
        }
      }
    },
    longitude(lng) {
      if (lng && self.google) {
        const self = this;
        self.longitude = lng;

        if (self.marker) {
          self.marker.setPosition(
            new self.google.maps.LatLng(self.latitude, self.longitude)
          );
        } else {
          self.marker = new self.google.maps.Marker({
            position: location,
            map: self.map,
            draggable: true
          });

          self.google.maps.event.addListener(self.marker, "drag", function(
            event
          ) {
            self.sendCoordinates(event.latLng.lat(), event.latLng.lng());
          });
          self.marker.setPosition(
            new self.google.maps.LatLng(self.latitude, self.longitude)
          );
        }
      }
    }
  }
};
</script>
